import axios from "axios";
import { APIClient } from "./axiosClient";

const api = new APIClient();
const path = "/upload/presigned-url";

export const createPathCloudFrame = (data: any) => {
  return api
    .post(path, data);
};

export const putUpload = async (params: { url: string, file: File }): Promise<boolean> => {
    try {
        
      const { url , file } = params;
      const file_buffer = await file.arrayBuffer()
      
      await axios.put(url, file_buffer, {
        headers: { 'Content-Type': file.type },
        transformRequest: (data, headers) => {
          if (headers?.Authorization) {
            delete headers?.Authorization;
          }
          return data
        }
      })

      return true;
    } catch (error) {
        console.log(error)
      return false
    }
} 

export function uploadFiles(files: any) {
  const url = "/upload/files";
  return api.post(url, files, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
